/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailDto
 */
export interface EmailDto {
    /**
     * User's email.
     * @type {string}
     * @memberof EmailDto
     */
    value?: string;
}

/**
 * Check if a given object implements the EmailDto interface.
 */
export function instanceOfEmailDto(value: object): boolean {
    return true;
}

export function EmailDtoFromJSON(json: any): EmailDto {
    return EmailDtoFromJSONTyped(json, false);
}

export function EmailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function EmailDtoToJSON(value?: EmailDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

